import { EventEmitter } from '@angular/core';

export class EventEmitterService {

    static EVENTOS = {
        NOTIFICATION_READ: 'NOTIFICATION_READ',
        SCROLL_TOP: 'SCROLL_TOP',
        SEARCH_MOBILE: 'SEARCH_MOBILE',
        HIDE_SEARCH: 'HIDE_SEARCH',
        SHOW_SEARCH: 'SHOW_SEARCH',
        ADICIONAR_FAB_BTN: 'ADICIONAR',
        AVANCAR: 'AVANCAR',
        BUSCA_TEXTUAL: 'BUSCA_TEXTUAL',
        SALVAR_CADASTRO: 'SALVAR_CADASTRO',
        MODULO_RECURSOS_FISICOS: 'MODULO_RECURSOS_FISICOS',
        UPDATE_PERFIL_ESFERA: 'UPDATE_PERFIL_ESFERA'
    };

    private static emitters: {
        [nomeEvento: string]: EventEmitter<any>
    } = {};

    static get(nomeEvento: string): EventEmitter<any> {
        if (!this.emitters[nomeEvento]) {
            this.emitters[nomeEvento] = new EventEmitter<any>();
        }
        return this.emitters[nomeEvento];
    }

}
